<template>
  <FlexTable class="weekly-consumption-table">
    <div class="flex-th table-title">Distribución de macronutrientes ({{calories}} kcal)</div>
    <div class="flex-trow flex-trow-header">
      <div class="flex-th">Macronutriente</div>
      <div class="flex-th">Gramos</div>
      <div class="flex-th">Calorías</div>
      <div class="flex-th">Porcentaje</div>
    </div>
    <div class="flex-trow flex-trow-content">
      <div class="flex-td"> Proteína (4kcal/gr) </div>
      <div class="flex-td"> {{proteinGrams}} </div>
      <div class="flex-td"> {{proteinCalories}} </div>
      <div class="flex-td"> {{proteinPercentage + "%"}} </div>
    </div>
    <div class="flex-trow flex-trow-content">
      <div class="flex-td"> Lípidos (9kcal/gr) </div>
      <div class="flex-td"> {{lipidGrams}} </div>
      <div class="flex-td"> {{lipidCalories}} </div>
      <div class="flex-td"> {{lipidPercentage + "%"}} </div>
    </div>
    <div class="flex-trow flex-trow-content">
      <div class="flex-td"> Carbohidratos (4kcal/gr) </div>
      <div class="flex-td"> {{choGrams}} </div>
      <div class="flex-td"> {{choCalories}} </div>
      <div class="flex-td"> {{choPercentage + "%"}} </div>
    </div>
    <div class="flex-trow flex-trow-header">
      <div class="flex-th"> Total </div>
      <div class="flex-th"> </div>
      <div class="flex-th"> {{totalCalories}} </div>
      <div class="flex-th"> {{totalPercentage + "%"}} </div>
    </div>
  </FlexTable>
</template>

<script>
import FlexTable from "./base/FlexTable";
import EditableCellInput from "../EditableCellInput";
import EditableCellSelect from '../EditableCellSelect';

export default {
  name: "MacronutrientsTable",
  components: { EditableCellSelect, EditableCellInput, FlexTable },
  props: {
    calories: {
      type: [Number, String]
    },
    proteinGrams: {
      type: [Number, String]
    },
    lipidGrams: {
      type: [Number, String]
    },
    choGrams: {
      type: [Number, String]
    },
  },
  data: function() {
    return {}
  },
  methods: {

  },
  computed:{
    proteinCalories: function () {
      let protein = this.proteinGrams
      if (protein) {
        return Number(protein) * 4
      } else {
        return "--"
      }
    },
    lipidCalories: function () {
      let lipid = this.lipidGrams
      if (lipid) {
        return Number(lipid) * 9
      } else {
        return "--"
      }
    },
    choCalories: function () {
      let cho = this.choGrams
      if (cho) {
        return Number(cho) * 4
      } else {
        return "--"
      }
    },
    totalCalories: function () {
      let protein = this.proteinCalories
      let lipid = this.lipidCalories
      let cho = this.choCalories
      if (protein === "--" || lipid === "--" || cho === "--") {
        return "--"
      } else {
        return Number(protein) + Number(lipid) + Number(cho)
      }
    },
    proteinPercentage: function () {
      let protein = this.proteinCalories
      let calories = this.calories
      if (calories && protein!== "--") {
        return ((protein * 100)/calories).toFixed(0)
      } else {
        return "--"
      }
    },
    lipidPercentage: function () {
      let lipid = this.lipidCalories
      let calories = this.calories
      if (calories && lipid!== "--") {
        return ((lipid * 100)/calories).toFixed(0)
      } else {
        return "--"
      }
    },
    choPercentage: function () {
      let cho = this.choCalories
      let calories = this.calories
      if (calories && cho!== "--") {
        return ((cho * 100)/calories).toFixed(0)
      } else {
        return "--"
      }
    },
    totalPercentage: function () {
      let protein = this.proteinCalories
      let lipid = this.lipidCalories
      let cho = this.choCalories
      let calories = this.calories
      if (protein === "--" || lipid === "--" || cho === "--" || isNaN(calories)) {
        return "--"
      } else {
        return (((Number(protein) + Number(lipid) + Number(cho)) * 100) / Number(calories) ).toFixed(0)
      }
    },
  }
}
</script>

<style scoped lang="scss">
$weekly-consumption-table-base-color: #517a51;
$weekly-consumption-table-title-bg-color: $weekly-consumption-table-base-color;
$weekly-consumption-table-title-color: $white;
$weekly-consumption-table-header-bg-color: rgba($weekly-consumption-table-base-color, 0.1);
$weekly-consumption-table-header-color: darken($weekly-consumption-table-base-color, 25);

.weekly-consumption-table {
  overflow-x: auto;
  padding: 4px;
  width: 100%;
  flex-direction: column;
  margin-bottom: 1rem;
}

.flex-th.table-title {
  background-color: $weekly-consumption-table-title-bg-color;
  color: white;
  position: sticky;
  left: 0;
  width: 100%;
}

.flex-th {
  background-color: $weekly-consumption-table-header-bg-color;
  color: $weekly-consumption-table-header-color;
  padding: 0.25rem;
}

.flex-trow-header > .flex-th, .flex-trow-content > .flex-td {
  flex: 1 0 6rem;
}

.flex-trow-header > .flex-th.num-cell, .flex-trow-content > .flex-td.num-cell {
  flex: 1 0 6rem;
}

.flex-trow-header > .flex-th.details-th, .flex-trow-content > .flex-td.details-td {
  flex: 1 0 27rem;
}

.with-unit {
  position: relative;

  & input {
    padding-top: 0;
    padding-bottom: 1rem;
  }

  & select {
    display: block;
    color: $gray-500;
    font-size: $font-size-sm;
    position: absolute;
    top: 50%;
    line-height: 1.3em;

    &:hover:not([disabled]) {
      color: $body-color;
    }

    &:hover[disabled] {
      background-color: transparent;
      cursor: unset;
    }

    &:active, &:focus {
      color: $body-color;
      background-color: $active-background-color;
    }
  }
}

// Hide incremental arrows
/* Chrome, Safari, Edge, Opera */
.editable-cell input::-webkit-outer-spin-button,
.editable-cell input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.editable-cell input[type=number] {
  -moz-appearance: textfield;
}
</style>